import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api, photoSrc } from "../lib/api";
import { Flame, Sparkles } from "lucide-react";

export default function MatchOverlay({ me, other, matchId, otherUserId, onClose }) {
  const navigate = useNavigate();
  const confetti = Array.from({ length: 24 });
  const [blurb, setBlurb] = useState("");

  useEffect(() => {
    if (!otherUserId) return;
    api.post("/ai/compatibility", { target_user_id: otherUserId })
      .then(({ data }) => setBlurb(data.blurb))
      .catch(() => {});
  }, [otherUserId]);

  return (
    <div data-testid="match-overlay" className="absolute inset-0 z-50 flex flex-col items-center justify-center px-8 overflow-hidden"
      style={{ background: "radial-gradient(circle at center, rgba(255,46,99,0.4) 0%, rgba(13,12,18,0.97) 70%)" }}>
      {confetti.map((_, i) => (
        <span key={i} className="absolute top-0 w-2 h-3 rounded-sm"
          style={{
            left: `${(i * 4.1) % 100}%`,
            background: ["#FF2E63", "#FFB703", "#00D2FF", "#FF6B8B"][i % 4],
            animation: `confetti-fall ${2 + (i % 5) * 0.4}s linear ${(i % 7) * 0.15}s infinite`,
          }} />
      ))}

      <div className="flex items-center gap-2 mb-8 relative z-10">
        <Flame className="w-7 h-7 text-amber-400" fill="currentColor" />
        <h2 className="text-3xl font-black text-white text-center" style={{ fontFamily: "Outfit, sans-serif" }}>
          It's a Match!
        </h2>
      </div>

      <div className="flex items-center -space-x-5 mb-6 relative z-10">
        <Avatar url={me} ring="ring-amber-400" />
        <Avatar url={other} ring="ring-rose-500" />
      </div>

      <p className="text-slate-300 text-center mb-4 relative z-10">
        You both liked each other in Kalaburagi. Say hello! 👋
      </p>

      {blurb && (
        <div data-testid="compatibility-blurb" className="relative z-10 mb-6 max-w-sm px-4 py-3 rounded-2xl bg-white/5 border border-rose-400/30 backdrop-blur-sm">
          <p className="text-sm text-rose-100 text-center leading-snug flex items-start gap-2">
            <Sparkles className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
            <span>{blurb}</span>
          </p>
        </div>
      )}

      <div className="w-full flex flex-col gap-3 relative z-10">
        <button
          data-testid="match-send-message-button"
          onClick={() => navigate(`/chat/${matchId}`)}
          className="h-13 py-3.5 rounded-2xl bg-gradient-to-r from-[#FF2E63] to-[#FF6B8B] text-white font-bold shadow-lg shadow-rose-500/30 active:scale-[0.98] transition-transform"
        >
          Send a Message
        </button>
        <button
          data-testid="match-keep-swiping-button"
          onClick={onClose}
          className="h-13 py-3.5 rounded-2xl bg-white/10 border border-white/15 text-white font-semibold active:scale-[0.98] transition-transform"
        >
          Keep Swiping
        </button>
      </div>
    </div>
  );
}

function Avatar({ url, ring }) {
  return (
    <div className={`w-28 h-28 rounded-full overflow-hidden ring-4 ${ring} bg-[#15121E] shadow-2xl`}>
      {url ? <img src={photoSrc(url)} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-slate-700" />}
    </div>
  );
}
